/* istanbul ignore file */
import React from 'react';

import { isDirectoriesAllowed } from '@lumapps/directories/ducks/selectors';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';

import { DirectoriesSettingsMenu as UI, DirectoriesSettingsMenuProps } from './DirectoriesSettingsMenu';

export const DirectoriesSettingsMenu: React.FC<Pick<DirectoriesSettingsMenuProps, 'scope'>> = ({ scope }) => {
    const isAllowed = useSelector(isDirectoriesAllowed);
    const isSuperAdmin = useSelector(isInstanceSuperAdmin);

    return <UI isAllowed={isAllowed || isSuperAdmin} scope={scope} />;
};
